// extracted by mini-css-extract-plugin
var _1 = "ETLxtF3YvP5mEJnvjxuB";
var _2 = "fIHn4KAQJeGvhLqLvXDi";
export { _1 as "list", _2 as "title" }
